import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder');

const SubscriptionModal = ({ isOpen, onClose, userEmail }) => {
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (priceId) => {
    setLoading(true);
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          priceId, 
          customerEmail: userEmail,
          successUrl: `${window.location.origin}?success=true`,
          cancelUrl: `${window.location.origin}?canceled=true`
        })
      });
      
      const { sessionId } = await response.json();
      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId });
    } catch (error) {
      console.error('Subscription error:', error);
    }
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>Choose Your Plan</h2>
        
        <div className="pricing-plans">
          <div className="plan">
            <h3>MyVoiceMe Premium</h3>
            <div className="price">$4.99/month</div>
            <div className="trial-info">30-day free trial</div>
            <ul>
              <li>Unlimited voice notes</li>
              <li>Advanced transcription</li>
              <li>Offline access</li>
              <li>Priority support</li>
            </ul>
            <button 
              onClick={() => handleSubscribe('price_myvoiceme_monthly')}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Start Free Trial'}
            </button>
          </div>
        </div>
        
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default SubscriptionModal;
